import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { paths } from 'config/paths';
import { useAuthContext } from 'contexts/auth.context';
import { useSendOtp } from 'lib/hooks/auth/auth.mutations';
import { useFetchMe } from 'lib/hooks/user/user.queries';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Logo from '../../images/logo.png';
import SendOtp from './SendOtp/SendOtp';
import VerifyOtp from './VerifyOtp/VerifyOtp';

function TwoFactorAuthComponent() {
  const [mobileLastFour, setMobileLastFour] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);

  const history = useHistory();

  const { user } = useAuthContext();

  const sendOtpMutation = useSendOtp();
  //This api call is needed to check outage error.
  const { error } = useFetchMe();
  useEffect(() => {
    if (error) {
      const errorData = (error as any)?.data;
      if (errorData?.outage) {
        history.push('/maintenance');
      } else {
        localStorage.clear();
        history.push(paths.login.path);
      }
    }
  }, [error, history]);

  useEffect(() => {
    document.title = 'Two Factor Authentications | UltraIoT';
  }, []);

  const hasSentOtp = useRef(false);

  useEffect(() => {
    if (!user) {
      localStorage.clear();
      history.push(paths.login.path);
      return;
    }
    setIsLoading(false);
    //sendOtp api will be called only once, if the below condition gets satisfied.
    if (
      user.phone &&
      user.countryCode &&
      user.is2FAEnabled === 1 &&
      !hasSentOtp.current
    ) {
      setIsOtpSent(true);
      hasSentOtp.current = true;
      otpFlow();
    }

    //this prevents repetitive api call
    if (hasSentOtp.current) return;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, history]);

  const otpFlow = async () => {
    if (!user) return;
    try {
      const res = await sendOtpMutation.mutateAsync({
        userId: user.id,
      });

      if (res?.success) {
        setMobileLastFour(user.phone.slice(-4));
        setIsOtpSent(true);
      } else {
        setIsOtpSent(false);
      }
    } catch {
      setIsOtpSent(false);
    }
  };

  return (
    <div className="oauth-authentication-2-0">
      <header className="oauth-authentication-header">
        <div className="oauth-authentication-logo">
          <img className="logo" src={Logo} alt="Ultra" width="100" />
        </div>
      </header>
      <div className="oauth-authentication-inner">
        <div className="oauth-authentication-body">
          <div className="card mb-0">
            <Spin
              size="large"
              spinning={isLoading}
              indicator={
                <LoadingOutlined style={{ fontSize: 30, color: '#000' }} spin />
              }
              aria-label="loading"
            >
              <div className="card-body">
                {!isLoading && !isOtpSent && (
                  <SendOtp
                    onSent={(mobileLastFourDigits) => {
                      setMobileLastFour(mobileLastFourDigits);
                      setIsOtpSent(true);
                    }}
                  />
                )}
                {isOtpSent && <VerifyOtp mobileLastFour={mobileLastFour} />}
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwoFactorAuthComponent;
